import React from "react";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] border-t border-white/8 overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="font-heading text-[20vw] font-black text-white/[0.025] tracking-tighter leading-none whitespace-nowrap">
          OBSIDIAN
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center mb-6">
              <div className="font-heading text-white tracking-[0.2em] text-sm uppercase">
                Obsidian<span className="text-blue-500">.</span>Auto
              </div>
            </div>
            <h3 className="font-heading text-white text-3xl md:text-4xl tracking-tighter font-light max-w-md">
              Studio-grade detailing.
              <br />
              <span className="font-medium">At your driveway.</span>
            </h3>
            <a
              href="#booking"
              data-testid="footer-book-btn"
              className="inline-flex items-center mt-8 bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 text-sm font-medium tracking-wide transition-colors"
            >
              Book a detail
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Visit</p>
            <ul className="space-y-3 text-zinc-300 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-blue-400 mt-0.5" />
                <span>118 Garage Lane<br />Brooklyn, NY 11201</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-blue-400" />
                <span>+1 (555) 014-0188</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-blue-400" />
                <span>hello@obsidian.auto</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-5">Hours</p>
            <ul className="space-y-2 text-zinc-300 text-sm">
              <li className="flex items-center justify-between border-b border-white/5 pb-2">
                <span>Mon — Fri</span>
                <span className="text-zinc-500">8:00 — 19:00</span>
              </li>
              <li className="flex items-center justify-between border-b border-white/5 pb-2">
                <span>Saturday</span>
                <span className="text-zinc-500">9:00 — 18:00</span>
              </li>
              <li className="flex items-center justify-between">
                <span>Sunday</span>
                <span className="text-zinc-500">By appointment</span>
              </li>
            </ul>

            <div className="mt-8 flex items-center gap-3">
              <a
                href="#"
                aria-label="Instagram"
                className="w-10 h-10 border border-white/10 hover:border-blue-500 hover:bg-blue-500/10 flex items-center justify-center transition-colors text-zinc-400 hover:text-white"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} Obsidian Auto Detailing. Hand-crafted in Brooklyn.</p>
          <p className="tracking-[0.2em] uppercase">Pay on-site · No deposit</p>
        </div>
      </div>
    </footer>
  );
}
